import * as utils from './Utils';

export function getAppId(el) {
  const ovData = window.OnVoardData;
  const platform = utils.getEcommercePlatform();

  let appId = el.getAttribute('data-app-id');
  if (!appId && platform === 'shopline') {
    if (ovData && ovData.config) {
      appId = ovData.config['backinstock_id'];
    }
  }

  if (appId && !el.getAttribute('data-app-id')) {
    el.setAttribute("data-app-id", appId);
  }

  return appId;
}


export function setupPlacement(instance, appName, className) {
  if (!instance.isSelectorPlacement) return;

  let referenceNode = document.querySelector(instance.placementCssSelector);
  if (!referenceNode) {
    instance.setEl(null);
    return;
  }

  let el = document.createElement("div");
  el.className = className;
  el.setAttribute("data-app", appName);
  el.setAttribute("data-app-id", instance.id);

  if (instance.insertPositionBefore) {
    referenceNode.parentNode.insertBefore(el, referenceNode);
  }

  if (instance.insertPositionAfter) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
  }

  instance.setEl(el);
}

export function loadCustomStyles(instance, styles, elementIdPrefix) {
  let el = instance.el;
  updateAppElementStyles(instance);

  let elementId = `${elementIdPrefix}_${instance.id}`;
  let existingTag = document.getElementById(elementId);
  if (existingTag) existingTag.remove();

  let innerHTML = styles;
  if (utils.isProduction()) innerHTML = instance.cssStyles || "";

  let tag = document.createElement('style');
  tag.id = elementId;
  tag.innerHTML = innerHTML;
  el.after(tag);

  // custom css styles
  if (instance.customCssStyles) {
    elementId = `${elementIdPrefix}_custom_${instance.id}`;
    existingTag = document.getElementById(elementId);
    if (existingTag) existingTag.remove();

    tag = document.createElement('style');
    tag.id = elementId;
    tag.innerHTML = instance.customCssStyles;
    el.after(tag);
  }

  // add css classes
  if (instance.cssClasses && instance.cssClasses.length) {
    instance.cssClasses.forEach((cssClass) => {
      if (el.classList.contains(cssClass)) return;
      el.classList.add(cssClass);
    })
  }
}


export function updateAppElementStyles(instance) {
  const el = instance.el;
  if (!el) return;

  if (instance.display) {
    el.style.display = "block";
  } else {
    el.style.display = "none";
  }
}

export function updateDisplay(instance, display) {
  let platform = utils.getEcommercePlatform();
  instance.setDisplay(display);
  updateAppElementStyles(instance);

  if (platform === 'wix') {
    import('common/wix-utils')
    .then((wixUtils) => {
      wixUtils.refreshBuiltInBackInStock();
    });
  }
}

export function retryInsert(instance, successTasks, setupPlacementCallback) {
  let handle = window.setInterval(() => {
    instance.incrPlacementInsertRetries();

    if (instance.placementInsertRetries >= 10 || instance.rendered) {
      clearInterval(handle);
      return;
    }

    setupPlacementCallback(instance);
    if (instance.el) {
      clearInterval(handle);
      successTasks();
      return;
    }

  }, 1000*1);
}


export function getPayloadQs() {
  let qs = {};

  let platform = utils.getEcommercePlatform();
  if (platform === 'shopware') {
    qs['product_id'] = window.OnVoardData.product ? window.OnVoardData.product.id : null;
  }

  return qs;
}

export function checkValidityWithTags(instance, tags) {
  if (!instance.tagsWhitelist.length && !instance.tagsBlacklist.length) return true;

  tags = tags.map((tag) => tag.toLowerCase());

  if (instance.tagsBlacklist.length) {
    if (tags.some((tag) => instance.tagsBlacklist.includes(tag))) return false;
  }

  if (instance.tagsWhitelist.length) {
    if (!(tags.some((tag) => instance.tagsWhitelist.includes(tag)))) return false;
  }

  return true;
}


export function attachUrlChangeEvents(instance) {
  utils.attachUrlChangeEvent();
  window.addEventListener('ovurlchange', () => {
    computeAvailabilityFromUrl(instance);
  });
}


export function computeAvailabilityFromUrl(instance) {
  let ovData = window.OnVoardData || window.OnVoardBackInStockData;
  if (!ovData) return;

  const product = ovData.product;
  if (!product) return;
  if (instance.isStockoutDisplayAny) return;
  if (!checkValidityWithTags(instance, product.tags)) {
    updateDisplay(instance, false);
    return;
  }

  if (instance.isShopify || instance.isEasyStore) {
    let variant = extractVariantFromUrl(instance, product);

    if (variant) {
      if (typeof instance.setVariantId !== 'undefined') {
        instance.setVariantId(variant.id.toString());
      }

      if (variant.available) updateDisplay(instance, false);
      if (!variant.available) updateDisplay(instance, true);
      return;
    }
  }

  if (instance.isShopline) {
    const sku = extractParamValuesFromUrl(['sku', "variant", "variantid"]);
    if (!sku) return;

    let variant = product.variants.filter((v) => v.id.toString() === sku)[0];
    if (variant) {
      if (typeof instance.setVariantId !== 'undefined') {
        instance.setVariantId(variant.id.toString());
      }

      if (variant.available) updateDisplay(instance, false);
      if (!variant.available) updateDisplay(instance, true);
      return;
    }
  }
}



export function extractParamValuesFromUrl(keys) {
  let variantId = null;
  let qs = utils.parseQueryString(window.location.search);

  for (let [key, value] of Object.entries(qs)) {
    if (variantId) return;

    // convert to lower case and only keep a-z 0-9 characters
    key = key.toLowerCase().replace(/[^a-z0-9]/gi, '');

    if (!keys.includes(key)) return;
    variantId = value.toString();
  }

  return variantId;
}


export function extractVariantIdFromUrl() {
  const eligibleKeys = [
    "variant",
    "variantid",
  ];

  return extractParamValuesFromUrl(eligibleKeys);
}


export function extractVariantFromUrl(instance, product) {
  const variantId = extractVariantIdFromUrl();
  if (!variantId) return;

  let variant = null;
  if (instance.isShopify || instance.isEasyStore) {
    variant = product.variants.filter((v) => v.id.toString() === variantId)[0];
  }

  return variant;
}



//=======================================
// Shopify
//=======================================
export function onReadyShopify(instance, ovData) {
  if (!ovData) {
    console.error(`Missing "OnVoardData" in window object`);
    return;
  }

  const template = ovData.template;
  const product = ovData.product;

  if (!product) return;
  if (!checkValidityWithTags(instance, product.tags)) return;
  if (!product.available) updateDisplay(instance, true);

  if (product.available) {
    if (instance.isStockoutDisplayAny) {
      if (product.variants.some((v) => !v.available)) {
        updateDisplay(instance, true);
      }
    }

    if (instance.isStockoutDisplaySelected) {
      let firstAvailableVariant = product.variants.filter((v) => v.available)[0];
      if (!firstAvailableVariant) updateDisplay(instance, true);
      computeAvailabilityFromUrl(instance);
    }
  }
}



//=======================================
// EasyStore
//=======================================
export function onReadyEasyStore(instance, ovData) {
  if (!ovData) {
    console.error(`Missing "OnVoardData" in window object`);
    return;
  }

  const product = ovData.product;

  if (!product) return;
  if (!checkValidityWithTags(instance, product.tags)) return;
  if (!product.available) updateDisplay(instance, true);

  if (product.available) {
    if (instance.isStockoutDisplayAny) {
      if (product.variants.some((v) => !v.available)) {
        updateDisplay(instance, true);
      }
    }

    if (instance.isStockoutDisplaySelected) {
      let variant = product.variants[0];
      if (variant && !variant.available) updateDisplay(instance, true);
      computeAvailabilityFromUrl(instance);
      attachEasyStoreSelectionChangeEvents(instance, product);
      updateEasyStoreSelectionChange(instance, product);
    }
  }
}

export function getEasyStoreProductParentSelectors() {
  return [
    '.product-single',
    '.product-form',
  ];
}


export function updateEasyStoreSelectionChange(instance, product) {
  let parentSelectors = getEasyStoreProductParentSelectors();
  let v = "";

  parentSelectors.forEach((parentSelector) => {
    if (v) return;

    document.querySelectorAll(`${parentSelector} .single-option-selector input:checked`).forEach((node) => {
      v += "," + node.value;
    });

    if (!v) {
      document.querySelectorAll(`${parentSelector} .single-option-selector option:checked`).forEach((node) => {
        v += "," + node.value;
      });
    }
  })

  let variantTitle = v.substring(1);
  let variant = product.variants.filter((v) => v.title === variantTitle)[0];

  if (variant) {
    if (typeof instance.setVariantId !== 'undefined') {
      instance.setVariantId(variant.id.toString());
    }

    if (variant.available) updateDisplay(instance, false);
    if (!variant.available) updateDisplay(instance, true);
    return;
  }
}

export function attachEasyStoreSelectionChangeEvents(instance, product) {
  let parentSelectors = getEasyStoreProductParentSelectors();
  parentSelectors.forEach((parentSelector) => {
    let elements = document.querySelectorAll(`${parentSelector} .single-option-selector`);

    Array.from(elements).forEach((el, idx) => {
     el.addEventListener('change', () => {
      updateEasyStoreSelectionChange(instance, product);
     });
    });
  })
}



//=======================================
// BigCommerce
//=======================================
export function onReadyBigCommerce(instance, ovData) {
  if (!ovData) {
    console.error(`Missing "OnVoardData" in window object`);
    return;
  }

  if (!ovData.product) return;
  if (!checkValidityWithTags(instance, ovData.product.tags)) return;

  import('common/bigcommerce-utils')
  .then((bcUtils) => {
    bcUtils.loadStorefrontProductData((sfProduct) => {
      let available = sfProduct.inventory.isInStock;
      if (!available) updateDisplay(instance, true);

      if (available) {
        if (instance.isStockoutDisplayAny) {
          if (sfProduct.variants.some((v) => !v.inventory.isInStock)) {
            updateDisplay(instance, true);
          }
        }

        if (instance.isStockoutDisplaySelected) {
          attachBigCommerceSelectionChangeEvents(instance, ovData);
        }
      }
    });
  });
}

export function attachBigCommerceSelectionChangeEvents(instance, ovData) {
  // with variant
  const triggerPaths = [
    `/remote/v1/product-attributes/${ovData.product.id}`,
  ];

  utils.interceptRequests(triggerPaths, (response, url) => {
    if (!(response instanceof Object)) response = JSON.parse(response);

    const variant = response.data;
    if (typeof instance.setVariantId !== 'undefined') {
      if (variant.v3_variant_id) instance.setVariantId(variant.v3_variant_id.toString());
    }

    let available = variant.instock;
    if (available) updateDisplay(instance, false);
    if (!available) updateDisplay(instance, true);
  });
}


//=======================================
// Shopline
//=======================================
export function onReadyShopline(instance, ovData) {
  if (!ovData) {
    console.error(`Missing "OnVoardData" in window object`);
    return;
  }

  const product = ovData.product;

  if (!product) return;
  if (!checkValidityWithTags(instance, product.tags)) return;
  if (!product.available) updateDisplay(instance, true);

  if (product.available) {
    if (instance.isStockoutDisplayAny) {
      if (product.variants.some((v) => !v.available)) {
        updateDisplay(instance, true);
      }
    }

    if (instance.isStockoutDisplaySelected) {
      let firstAvailableVariant = product.variants.filter((v) => v.available)[0];
      if (!firstAvailableVariant) updateDisplay(instance, true);
      computeAvailabilityFromUrl(instance);
    }
  }
}


//=======================================
// Shopware
//=======================================
export function onReadyShopware(btn, ovData) {
  if (!ovData) {
    console.error(`Missing "OnVoardData" in window object`);
    return;
  }

  const product = ovData.product;
  const available = product.available_stock > 0;

  if (!product) return;
  if (!checkValidityWithTags(btn, product.tags)) return;
  if (!available) updateDisplay(btn, true);

  if (available) {
    if (btn.isStockoutDisplayAny) {
      if (product.variants.some((v) => 0 >= product.available_stock)) {
        updateDisplay(btn, true);
      }
    }

    if (btn.isStockoutDisplaySelected) {
      let selectedVariant = product.variants.filter((v) => v.selected)[0];
      if (selectedVariant && 0 >= selectedVariant.available_stock) {
        updateDisplay(btn, true);
      }
    }
  }
}


//=======================================
// Wix
//=======================================
export function onWixVariantChange(defaultInstances) {
  let product = window.OnVoardData['product'];

  import('common/wix-utils')
  .then((wixUtils) => {
    if (!product.isInStock) return;

    // handle change for isStockoutDisplayAny
    let instances = defaultInstances.filter((instance) => instance.isStockoutDisplayAny);
    if (instances.some((instance) => instance.display)) {
      wixUtils.refreshBuiltInBackInStock();
    }

    // set false by default
    instances = defaultInstances.filter((instance) => instance.isStockoutDisplaySelected);
    instances.forEach((instance) =>  updateDisplay(instance, false));


    let showWidgetsCallback = () => {
      instances.forEach((instance) =>  updateDisplay(instance, true));
    };

    wixUtils.onVariantChange(showWidgetsCallback);
  });
}

export function onReadyWix(instance, ovData) {
  if (!ovData) {
    console.error(`Missing "OnVoardData" in window object`);
    return;
  }

  const product = ovData.product;
  if (!product) return;
  if (!product.isInStock) updateDisplay(instance, true);

  if (product.isInStock) {
    if (instance.isStockoutDisplayAny) {
      if (product.productItems.some((item) => 0 >= item.inventory.quantity)) {
        updateDisplay(instance, true);
      }
    }
  }
}

//=======================================
// WooCommerce
//=======================================
export function onReadyWooCommerce(instance, ovData) {
  if (!ovData) {
    console.error(`Missing "OnVoardData" in window object`);
    return;
  }

  const pageType = ovData.page_type;
  const product = ovData.product;
  let available = product.stock_status !== 'outofstock';

  if (!product) return;
  if (!checkValidityWithTags(instance, product.tags)) return;
  if (!available) updateDisplay(instance, true);

  if (available) {
    if (instance.isStockoutDisplayAny) {
      if (product.variations.some((v) => v.stock_status === 'outofstock')) {
        updateDisplay(instance, true);
      }
    }

    if (instance.isStockoutDisplaySelected) {
      attachWooCommerceSelectionChangeEvents(instance, product);
    }
  }
}

export function attachWooCommerceSelectionChangeEvents(instance, product) {
  if (typeof jQuery === 'undefined') return;

  jQuery(function($) {
      // On selected variation event
      $('form.variations_form').on('show_variation', (event, v_row) => {
        let variation = product.variations.filter((v) => `${v.id}` === `${v_row.variation_id}`)[0];
        if (variation) {
          if (typeof instance.setVariantId !== 'undefined') {
            instance.setVariantId(variation.id.toString());
          }

          let available = variation.stock_status !== 'outofstock';
          if (available) updateDisplay(instance, false);
          if (!available) updateDisplay(instance, true);
          return;
        }
      });

      // On unselected (or not selected) variation event
      $('form.variations_form').on('hide_variation', () => {
          if (typeof instance.setVariantId !== 'undefined') {
            instance.setVariantId("");
          }

          updateDisplay(instance, false);
      });
  });
}
